import React from 'react';
import { PropTypes } from 'prop-types';
import { texts } from 'utils/languages/fr';
import { Typography } from '@mui/material';

const ChartSubtitle = ({ selectedFund, subType, valueType }) => (
    <Typography variant="subtitle2" align="center">
        {selectedFund === 'all'
            ? texts[`${subType.toUpperCase()}_SUBSCRIPTIONS_${valueType.toUpperCase()}_BY_PRODUCT`]
            : texts[`${subType.toUpperCase()}_SUBSCRIPTIONS_${valueType.toUpperCase()}_BY_SHARE`]}
    </Typography>
);

ChartSubtitle.propTypes = {
    selectedFund: PropTypes.any.isRequired,
    subType: PropTypes.oneOf(['direct', 'indirect']),
    valueType: PropTypes.oneOf(['number', 'value']),
};

export default ChartSubtitle;
